import {
  hslToHex,
  isHslColor,
} from '@design/utils/color-conversion/color-conversion';

import { DesignToken, ThemeName, themes } from './themes';

export const getThemeColorInHex = (
  themeName: ThemeName,
  designToken: DesignToken | string
) => {
  const theme: Record<string, string> = themes[themeName];
  const themeColor = theme[designToken];

  if (isHslColor(themeColor)) {
    return hslToHex(themeColor);
  }

  return themeColor;
};

export const getThemeColor = (
  colorToken: DesignToken | string,
  themeName: ThemeName
): string => {
  const theme: Record<string, string> = themes[themeName];
  const themeColor = theme[colorToken];
  return themeColor ? getThemeColorInHex(themeName, colorToken) : colorToken;
};
